import { render } from "./SortDownIcon16.vue.js?vue&type=template&id=1af43af2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./SortDownIcon16.vue?vue&type=template&id=1af43af2"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__